<template>
	<div>
		<action-sidebar
			:title="title"
			:value="true"
			@close-modal="closeModal"
		>
			<accounting-account-form
				:id="accountId"
				:plan-id="id"
				:route="route"
				@on-close="closeModal"
			/>
		</action-sidebar>
	</div>
</template>

<script>
import actionSidebar from '@/components/shared/action-sidebar';
import accountingAccountForm from '@/components/accounting-accounts/accounting-account-form';

function closeModal() {
	const paramsAccount = {
		id: this.id,
		name: this.name,
		subsidiaryName: this.subsidiaryName,
		year: this.year,
	};
	const params = this.route === 'accounting-accounts' ? paramsAccount : {};
	setTimeout(() => {
		this.goTo(this.route, { params });
	}, 1000);
}

function title() {
	const module = 'Cuenta Contable';
	return this.$route.name.indexOf('edit') > -1 ? `Editar ${module}` : `Crear ${module}`;
}

export default {
	name: 'page-accounting-account-new',
	components: {
		actionSidebar,
		accountingAccountForm,
	},
	computed: {
		title,
	},
	methods: {
		closeModal,
	},
	props: {
		accountId: [Number, String],
		id: [Number, String],
		name: String,
		subsidiaryName: String,
		year: [Number, String],
		route: {
			default: 'accounting-accounts',
			type: String,
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/pages/accounting-accounts/page-accounting-account-new.vue